import React, { useEffect, useState } from "react";
import { Form, Row, Col, InputGroup, FormText } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { IconMail, IconPhone, IconUser } from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import { TagInput } from "rsuite";
import { toast } from "react-toastify";
import EmailSuggestions from "../../components/EmailSuggestions";
function SalesLead() {
  const [searchName, setSearchName] = useState("");
  const { debounceSearch } = useDebounce(searchName);
  const [suggestion, setSuggestion] = useState([]);
  const [userEmails, setUserEmails] = useState([]);

  const {
    register,
    setValue,
    formState: { errors },
    control,
  } = useFormContext();

  const {
    data: fetchdata,
    isLoading,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_RFQ_USERS);

  const {
    data: user,
    isLoading: userLoading,
    postData: fetchAllUsers,
  } = usePostRequest(API_ENDPOINTS.GET_ALL_USERS);

  const handleSelect = (item) => {
    setValue("sales_lead_username", item.username);
    setValue("sales_lead_name", `${item.first_name}${item.last_name}`);
    setValue("sales_lead_email", item.email);
    setValue("sales_lead_phone", item.phone);
    // setSearchName(item.first_name);

    setSuggestion(null);
  };

  useEffect(() => {
    fetchAllUsers({ module_type: "RFQ" });
  }, []);

  useEffect(() => {
    if (user?.data?.length > 0) {
      const validEmails = user.data
        .map((u) => u.email)
        .filter((email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));

      setUserEmails(validEmails);
    }
  }, [user]);

  const handleSearchByName = (e) => {
    setSearchName(e.target.value);
  };

  const onSuccessData = (data) => {
    setSuggestion(data);
  };

  useEffect(() => {
    if (searchName?.length > 0) {
      fetchRfq(
        {
          first_name: searchName,
          module_type: "RFQ",
        },
        onSuccessData
      );
    }
  }, [debounceSearch, searchName]);

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("sales_lead_name")}
                placeholder="Enter Name"
                // value={searchName}
                onChange={handleSearchByName}
              />
            </InputGroup>

            <div>
              {suggestion?.data?.length > 0 && searchName?.length > 0 && (
                <div className="suggestions">
                  {suggestion?.data.map((item, index) => {
                    return (
                      <div key={index}>
                        <div
                          className="suggestion-item"
                          onClick={() => handleSelect(item)}
                        >
                          <div className="suggestion-item__name">
                            {`${item?.first_name}${item.last_name}`}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {errors.sales_lead_name && (
              <span className="text-danger">
                {errors.sales_lead_name.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Email</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconMail stroke={1} />
              </InputGroup.Text>
              <Form.Control
                type="email"
                {...register("sales_lead_email")}
                placeholder="Enter Email"
              />
            </InputGroup>
            {errors.sales_lead_email && (
              <span className="text-danger">
                {errors.sales_lead_email.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Phone</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconPhone stroke={1} />
              </InputGroup.Text>
              <Form.Control
                type="number"
                {...register("sales_lead_phone")}
                placeholder="Enter Phone"
              />
            </InputGroup>
            {errors.sales_lead_phone && (
              <span className="text-danger">
                {errors.sales_lead_phone.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Notification Email(s)</Form.Label>
            <Controller
              name="notification_emails"
              control={control}
              defaultValue={[]}
              render={({ field }) => (
                <EmailSuggestions
                  {...field}
                  suggestionsSource={userEmails}
                  validate={(email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                  errorMessage="Invalid email format"
                  placeholder="Enter email and press Enter"
                />
              )}
            />

            {errors.notification_emails && (
              <span className="text-danger">
                {errors.notification_emails.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              Opportunity WON Notification Email(s)
            </Form.Label>
            <Controller
              name="rfqwon_notification_emails"
              control={control}
              defaultValue={[]}
              render={({ field }) => (
                <EmailSuggestions
                  {...field}
                  suggestionsSource={userEmails}
                  validate={(email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                  errorMessage="Invalid email format"
                  placeholder="Enter email and press Enter"
                />
              )}
            />

            {errors.rfqwon_notification_emails && (
              <span className="text-danger">
                {errors.rfqwon_notification_emails.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              Order PENDING Notification Email(s)
            </Form.Label>
            <Controller
              name="orderpending_notification_emails"
              control={control}
              defaultValue={[]}
              render={({ field }) => (
                <EmailSuggestions
                  {...field}
                  suggestionsSource={userEmails}
                  validate={(email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                  errorMessage="Invalid email format"
                  placeholder="Enter email and press Enter"
                />
              )}
            />

            {errors.orderpending_notification_emails && (
              <span className="text-danger">
                {errors.orderpending_notification_emails.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              Order IN PROGRESS Notification Email(s)
            </Form.Label>
            <Controller
              name="orderprogress_notification_emails"
              control={control}
              defaultValue={[]}
              render={({ field }) => (
                <EmailSuggestions
                  {...field}
                  suggestionsSource={userEmails}
                  validate={(email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                  errorMessage="Invalid email format"
                  placeholder="Enter email and press Enter"
                />
              )}
            />

            {errors.orderprogress_notification_emails && (
              <span className="text-danger">
                {errors.orderprogress_notification_emails.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <input type="hidden" {...register("sales_lead_username")} />
        <Row>
          <Form.Group as={Col}>
            <div className="d-flex flex-wrap gap-3">
              <Form.Label className="w-md-auto fw-bold">
                Wants to send updates to the vendor? :
              </Form.Label>
              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="yes"
                  value="1"
                  {...register("notifyEmailsVendor")}
                />
                <Form.Check.Label htmlFor="yes">YES</Form.Check.Label>
              </Form.Check>
              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="no"
                  value="0"
                  {...register("notifyEmailsVendor")}
                />
                <Form.Check.Label htmlFor="no">NO</Form.Check.Label>
              </Form.Check>
            </div>
          </Form.Group>
          <Form.Group as={Col}>
            <div className="d-flex flex-wrap gap-3">
              <Form.Label className="w-md-auto fw-bold">
                Wants to send updates to the customer? :
              </Form.Label>
              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="yes"
                  value="1"
                  {...register("notifyEmails")}
                />
                <Form.Check.Label htmlFor="yes">YES</Form.Check.Label>
              </Form.Check>
              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="no"
                  value="0"
                  {...register("notifyEmails")}
                />
                <Form.Check.Label htmlFor="no">NO</Form.Check.Label>
              </Form.Check>
            </div>
          </Form.Group>
        </Row>
        {/* <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
              Wants to send updates to the customer? :
            </Form.Label>
            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="yes"
                value="1"
                {...register("notifyEmails")}
              />
              <Form.Check.Label htmlFor="yes">YES</Form.Check.Label>
            </Form.Check>
            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="no"
                value="0"
                {...register("notifyEmails")}
              />
              <Form.Check.Label htmlFor="no">NO</Form.Check.Label>
            </Form.Check>
          </div>
        </Form.Group> */}
      </Row>
    </>
  );
}

export default SalesLead;
